/**
 * The literal a deployment sets in place of a SaaS key to say "this integration
 * is off here, use the application's defaults". Only `VITE_FLAGSMITH_TOKEN`
 * accepts it today.
 */
export const USE_DEFAULT = 'USE_DEFAULT';
